import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31d9da7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flexDiv" }
const _hoisted_2 = { style: {"margin-top":"20px"} }

import { reactive, onMounted, ref, watch } from 'vue';

import { ElMessage, ElTree } from 'element-plus';
import { Search } from '@element-plus/icons-vue';

/* Apis */
import { GetParentListApi } from '../../../apis/ct_categorys/category.api'


export default /*#__PURE__*/_defineComponent({
  emits: ['nodeChange'],
  setup(__props, { emit: $emits }) {



const treeRef = ref<InstanceType<typeof ElTree>>();

const datalist = ref<any[]>([])
const state = reactive({
    filterText: ''
})

const filterNode = (value: string, data: any) => {
    if (!value) return true
    return data.name.includes(value)
}

/* 加载数据 */
const load = {
    getCompanyList: async () => {

        datalist.value.push({ name: '合同分类', value: '', children: [] })

        const { succeeded, errors, data } = await GetParentListApi()

        if (!succeeded)
            ElMessage.error(errors)
        else {

            (data || []).forEach((item: any) => {

                datalist.value[0].children.push(item)
            })
        }
    }
}

watch(() => state.filterText, (val: string) => {
    treeRef.value!.filter(val);
});

/* 点击节点 */
const onTreeNodeClick = (node: any) => {
    $emits('nodeChange', node.id)
}

onMounted(() => {
    load.getCompanyList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_input, {
          "prefix-icon": _unref(Search),
          modelValue: _unref(state).filterText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).filterText) = $event)),
          placeholder: "请输入关键字查询"
        }, null, 8, ["prefix-icon", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElTree), {
          ref_key: "treeRef",
          ref: treeRef,
          data: datalist.value,
          props: { label: 'name' },
          "filter-node-method": filterNode,
          "default-expand-all": "",
          "highlight-current": "",
          "node-key": "id",
          "expand-on-click-node": false,
          onNodeClick: onTreeNodeClick
        }, null, 8, ["data"])
      ])
    ]),
    _: 1
  }))
}
}

})